<template>
  <div class="report">
    <div class="scroll">
      <div class="cont">
        <div class="top">
          <h2>作业成绩</h2>
          <p v-if="data.getScore>0">满分{{data.totalScore}}分</p>
          <ul>
            <li
              class="cursor"
              v-for="(v, i) in data.progress"
              :class="{
                cur: v.status==0,
                suc: v.status==2,
                mr0: (i + 1) % 10 == 0,
              }"
              :key="i"
              @click="analysis(v,i)"
            >
              {{ v.index }}
            </li>
          </ul>
          <button class="cursor" @click="btnClick">查看解析</button>
          <em v-if="data.getScore>0">{{data.getScore}}分</em>
        </div>
        <div class="bottom" v-if="data.totalCoin>0">
          <h2>金币奖励</h2>
          <p>小朋友，题目作答正确即可获得金币哟，本次奖励明细：</p>
          <em>奖励金币数&nbsp;<i>{{data.totalCoin}}枚</i></em>
          <ul>
            <li v-for="(v, i) in data.progress" :key="i" :class="{ mr0: (i + 1) % 5 == 0 }">
              <b>第{{ v.index }}题：</b>
              <b>{{v.getCoin}}枚</b>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  created() {},
  props:{
    data:{
      type:Object,
      required:true
    }
  },
  methods: {
    analysis(item,index) {
      if(item.status==0){//订正
        this.$emit("revision",item)
      }else{//解析
        this.$emit("analysis",index+1)
      }
      // console.log(item)
    },
    btnClick(){
      this.$emit("analysis",1)
    }
  },
};
</script>
<style lang="less" scoped rel="stylesheet/less">
.report {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #c9efff;
  overflow-y: auto;
}
::-webkit-scrollbar {
  width: 2px;
}
.scroll{
  width: 1100px;
  height: 100%;
  margin: 0 auto;

}
.cont {
  width: 100%;
  height: auto;
  padding-bottom: 23px;
}
.top {
  position: relative;
  width: 100%;
  min-height: 352px;
  background: #ffffff;
  border-radius: 30px;
  margin-top: 43px;
  p {
    font-size: 18px;
    text-align: center;
    color: #004466;
  }
  button {
    width: 150px;
    height: 50px;
    line-height: 50px;
    background: linear-gradient(180deg, #5cccee, #52c5ec, #31b1e5 88%);
    border-radius: 24px;
    font-size: 20px;
    text-align: center;
    color: #ffffff;
    margin: 23px 0;
  }
  em {
    position: absolute;
    width: 103px;
    height: 60px;
    text-align: center;
    top: 26px;
    right: 46px;
    font-size: 30px;
    font-weight: 600;
    color: #ff4c4c;
    background: url("../../../assets/img/homework/line.png") no-repeat left 36px;
    background-size: 104px 24px;
  }
  ul {
    width: 1024px;
    margin: 0 auto;
    min-height: 160px;
    border-bottom: 1px solid #e5ecee;
    padding-bottom: 20px;
    text-align: left;
    li {
      position: relative;
      display: inline-block;
      width: 75px;
      height: 90px;
      min-width: 75px;
      border-radius: 8px;
      background: #f3f3f3;
      text-align: center;
      font-size: 30px;
      color: #666666;
      margin-right: 30px;
      margin-top: 26px;
      font-weight: 600;
      line-height: 2.2;
      &::after {
        content: "";
        font-weight: 400;
        width: 60px;
        height: 24px;
        line-height: 24px;
        left: 50%;
        margin-left: -30px;
        font-size: 14px;
        position: absolute;
        bottom: 7px;
        background: rgba(255, 255, 255, 0.24)
          url("../../../assets/img/common/success.png") no-repeat center;
        background-size: 17px;
        border-radius: 3px;
      }
    }
    .cur {
      background: #ff973d;
      color: #ffffff;
      box-shadow: 0px 5px 8px 0px rgba(221,102,0,0.30); 
    }
    .cur::after {
      content: "待订正";
      background-image: none;
    }
    .suc {
      background: #32bd8f;
      color: #ffffff;
      box-shadow: 0px 3px 5px 0px rgba(5,192,130,0.30)
    }
    .suc::after {
      content: "已订正";
      background-image: none;
    }
  }
}
.bottom {
  position: relative;
  width: 100%;
  min-height: 274px;
  background: #ffffff;
  border-radius: 30px;
  margin-top: 23px;
  p {
    padding: 32px 0 16px 38px;
    opacity: 0.8;
    font-size: 19px;
    text-align: left;
    color: #004466;
  }
  em {
    position: absolute;
    padding: 6px 25px;
    background: #e4f7ff;
    border-radius: 19px;
    font-size: 19px;
    color: #004466;
    top: 30px;
    right: 38px;
    font-weight: 600;
    i {
      color: #ec8c05;
      background: url("../../../assets/img/common/coin.png") no-repeat left
        center;
      background-size: 23px;
      padding-left: 26px;
    }
  }
  ul {
    width: 1024px;
    margin: 0 auto;
    min-height: 98px;
    border-top: 1px solid #e5ecee;
    padding-top: 10px;
    text-align: left;
    padding-bottom: 23px;
    li {
      display: inline-block;
      width: 172px;
      min-width: 120px;
      margin-top: 17px;
      font-size: 0;
      margin-right: 40px;
      b {
        color: #004466;
        display: inline-block;
        font-size: 20px;
      }
      b:first-child {
        width: 84px;
      }
      b:last-child {
        width: 88px;
        color: #ec8c05;
        background: url("../../../assets/img/common/coin.png") no-repeat left
          center;
        background-size: 23px;
        padding-left: 27px;
      }
    }
  }
}
h2 {
  font-size: 30px;
  color: #004466;
  padding-top: 27px;
  &::before,
  &::after {
    content: " ";
    display: inline-block;
    width: 32px;
    height: 25px;
    background: url("../../../assets/img/homework/card_l.png") no-repeat;
    background-size: cover;
    margin-right: 16px;
    transform: translateY(2px);
  }
  &::after {
    background: url("../../../assets/img/homework/card_r.png") no-repeat;
    background-size: cover;
    margin-left: 16px;
    margin-right: 0;
  }
}
.mr0 {
  margin-right: 0 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/bussiness/homework/report.vue